import type { Annotation, DrawingDocument } from '../model';

// Canvas annotations are pure decoration -- appending or dropping one touches nothing chemical,
// so no revision bump / perception invalidation (ADR 0008 R5.3).
export function appendAnnotation(document: DrawingDocument, annotation: Annotation): DrawingDocument {
  return { ...document, annotations: [...document.annotations, annotation] };
}

export function removeLastAnnotation(document: DrawingDocument): DrawingDocument {
  if (document.annotations.length === 0) return document;
  return { ...document, annotations: document.annotations.slice(0, -1) };
}
